module.exports = __webpack_public_path__ + "mm.svg?361afba5b3ba3e57ecea4bd3a965cf7b";